import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import Divider from "@material-ui/core/Divider";
import copy from "../../../../../assets/images/copy.png";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {getprofile} from '../../../../../api/api.js' ;

function ConnectMobile() {


    const {sharetoken} = useSelector(({auth}) => auth);
    const [token, setToken] = React.useState('');

    useEffect(() => {

        // var bodyFormData = new FormData();
        // bodyFormData.append('Guest', false);
        getprofile()
            .then((response) => {

                //listcontact = response.data.contact;
                setToken(response.data.Details.sharetoken);
            })
            .catch((error) => {


            });


    }, []);



    return (

        <div style={{display: 'flex', marginTop: 70, flexDirection: 'column'}}>



            <div style={{marginTop: 70, padding: 0}}
                 className="animated slideInUpTiny animation-duration-3 d-flex flex-column ">


                <div className="d-lg-none" style={{display: 'flex',flexDirection: 'column', justifyContent: 'center',marginRight:20,
        alignItems: 'center',padding:10}}>

                    <div style={{
                        textAlign: 'center',
                        marginTop: 50,
                        marginBottom: 50,
                        fontSize: 15,
                        fontFamily: 'iransans',
                        fontWeight: 'bold'
                    }}>
                        <div>
                            توکن اتصال یه سایت ...
                        </div>
                        {/*<div>*/}
                        {/*    {sharetoken}*/}
                        {/*</div>*/}
                    </div>

                    <div style={{ textAlign: 'center'}}>

                        <div
                        style={{
                            fontFamily: 'iransans',
                            border: '1px solid rgba(0, 0, 0, 0.23)',
                            borderRadius: 10,
                            fontSize: 5,
                            height: 50,
                            paddingLeft: 10,
                            paddingRight: 10,
                            marginBottom: 0,
                            display: 'flex',
                            backgroundColor: '#ffffff',
                            flexDirection: 'row-reverse',
                            alignItems: 'center',
                            color: 'rgba(0, 0, 0, 0.54)',
                        }}>
                        <CopyToClipboard text={token}
                                         onCopy={() => alert('کپی شد')}>
                            {/*<span>Copy to clipboard with span</span>*/}
                            <img style={{
                                fontSize: 13,
                                width: 30,
                                height: 30,
                                direction: 'ltr',
                                display: 'inline-block',
                                marginRight: 10
                            }} src={copy}>
                            </img>
                        </CopyToClipboard>
                        <Divider orientation="vertical" flexItem/>
                        <div style={{
                            fontFamily: 'iransans',
                            fontWeight: 'bold',
                            fontSize: 13,
                            marginLeft: 5,
                            textColor: '#000000'
                        }}>
                            {token}
                        </div>
                    </div>

                    </div>


                </div>

            </div>
        </div>

    );
}

export default ConnectMobile;




